import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { SpeedCatchup } from "@common/ADAPT.Common.Model/organisation/speed-catchup";
import { CatchupRatingValue, RatingValues } from "@common/ADAPT.Common.Model/organisation/speed-catchup-rating";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { PeerCatchupUiService } from "../peer-catchup-ui.service";

const TooltipText: { [key: string]: string } = {
    Green: "All individual ratings were green, indicating no issues exist",
    Orange: "One or more individual ratings were orange, indicating minor issues exist",
    Red: "One or more individual ratings were red, indicating major issues exist",
};

@Component({
    selector: "adapt-catchup-rating-cell",
    templateUrl: "./catchup-rating-cell.component.html",
    styleUrls: ["../peer-catchup-styles.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CatchupRatingCellComponent extends BaseComponent implements OnInit {
    @Input() public catchup!: SpeedCatchup;

    public ratingClass = "catchup-rating-unset";
    public tooltipText = "";

    public constructor(
        private peerCatchupUiService: PeerCatchupUiService,
    ) {
        super();
    }

    public ngOnInit() {
        const worstRating = this.catchup.ratings
            .map((i) => i.rating)
            .reduce((worstValue, currentValue) =>
                RatingValues[currentValue] > RatingValues[worstValue] ? currentValue : worstValue,
                CatchupRatingValue.Green);
        this.ratingClass = `catchup-rating-${worstRating}`;
        this.tooltipText = TooltipText[worstRating];
    }

    public showCatchup() {
        // can't use takeUntilDestroyed here, as changes to the catchup will cause the cell to be destroyed...
        this.peerCatchupUiService.showCatchup(this.catchup).subscribe();
    }

    public showHistory() {
        this.peerCatchupUiService.showCatchupHistoryChart(this.catchup.person1!, this.catchup.person2!).pipe(
            this.takeUntilDestroyed(),
        ).subscribe();
    }
}
